import { render, staticRenderFns } from "./CurrentChargesDetails.vue?vue&type=template&id=383db052&scoped=true"
import script from "./CurrentChargesDetails.vue?vue&type=script&lang=js"
export * from "./CurrentChargesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383db052",
  null
  
)

export default component.exports